import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import classnames from 'classnames'
import { RevealSection } from 'src/Components/shared/Transition'
import RefiOption from 'src/Components/shared/RefiOption'

import styles from './RefiOptionReveal.module.scss'

const propTypes = {
  className: PropTypes.string,
  dataQaTag: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  yearsInHome: PropTypes.number.isRequired,
  pmi: PropTypes.number,
  onClickOption: PropTypes.func,
  showCount: PropTypes.number,
  curtainHeight: PropTypes.number,
  locked: PropTypes.bool
}

export const RefiOptionReveal = ({
  className,
  options,
  yearsInHome,
  pmi,
  onClickOption,
  showCount = 3,
  curtainHeight = 105,
  locked
}) => {
  const [clipped, setClipped] = useState(true)
  const skipReveal = !clipped || options.length <= 3

  return (
    <div
      className={classnames(styles.overflow, className)}
      data-qa='refi-section-container'
    >
      <RevealSection
        className={styles.narrowReveal}
        curtainHeight={curtainHeight}
        showChildCount={showCount}
        shadowColor='purple'
        skipReveal={skipReveal}
        onReveal={() => setClipped(false)}
      >
        {options.map(o => (
          <RefiOption
            key={`${o.type}_${o.years}_narrow`}
            yearsInHome={yearsInHome}
            pmi={pmi}
            detail={o}
            locked={locked}
            horizontal
            onClick={() => onClickOption(o)}
          />
        ))}
      </RevealSection>

      <RevealSection
        className={styles.wideReveal}
        curtainHeight={curtainHeight}
        showChildCount={1}
        buttonBelow
        skipReveal={skipReveal}
        onReveal={() => setClipped(false)}
      >
        <div className={styles.exposed} key='ROR_shower'>
          {options.slice(0, showCount).map(o => (
            <RefiOption
              key={`${o.type}_${o.years}_wide`}
              yearsInHome={yearsInHome}
              pmi={pmi}
              detail={o}
              locked={locked}
              onClick={() => onClickOption(o)}
            />
          ))}
        </div>
        <div
          className={clipped ? styles.clipped : styles.notClipped}
          key='ROR_hider'
        >
          <div>
            {options.slice(3, options.length).map(o => (
              <RefiOption
                key={`${o.type}_${o.years}_wideHide`}
                yearsInHome={yearsInHome}
                pmi={pmi}
                detail={o}
                locked={locked}
                onClick={() => onClickOption(o)}
              />
            ))}
          </div>
        </div>
      </RevealSection>
    </div>
  )
}

RefiOptionReveal.propTypes = propTypes

export default RefiOptionReveal
